/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  SaveInsuranceErrorResponse,
  SaveInsuranceRequest,
  SaveInsuranceResponse,
} from './api.schemas';

import { api } from '../util/http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

export const createEncountersInsurance = (
  encounterId: number,
  saveInsuranceRequest: NonReadonly<SaveInsuranceRequest>,
  signal?: AbortSignal,
) => {
  return api<SaveInsuranceResponse>({
    url: `/api/encounters/${encounterId}/insurance`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: saveInsuranceRequest,
    signal,
  });
};

export const getCreateEncountersInsuranceMutationOptions = <
  TError = SaveInsuranceErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEncountersInsurance>>,
    TError,
    { encounterId: number; data: NonReadonly<SaveInsuranceRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEncountersInsurance>>,
  TError,
  { encounterId: number; data: NonReadonly<SaveInsuranceRequest> },
  TContext
> => {
  const mutationKey = ['createEncountersInsurance'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEncountersInsurance>>,
    { encounterId: number; data: NonReadonly<SaveInsuranceRequest> }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return createEncountersInsurance(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEncountersInsuranceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEncountersInsurance>>
>;
export type CreateEncountersInsuranceMutationBody = NonReadonly<SaveInsuranceRequest>;
export type CreateEncountersInsuranceMutationError = SaveInsuranceErrorResponse;

export const useCreateEncountersInsurance = <
  TError = SaveInsuranceErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEncountersInsurance>>,
      TError,
      { encounterId: number; data: NonReadonly<SaveInsuranceRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEncountersInsurance>>,
  TError,
  { encounterId: number; data: NonReadonly<SaveInsuranceRequest> },
  TContext
> => {
  const mutationOptions = getCreateEncountersInsuranceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
